import { render, staticRenderFns } from "./SponsorsList.vue?vue&type=template&id=c1e4e6da"
import script from "./SponsorsList.vue?vue&type=script&lang=js"
export * from "./SponsorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports